const ORDINARY = "ordinary";
const LONG_TERM_STAY = "long-term-stay";
const MULTI = "multi";
const DISCOUNT_TYPE = [ORDINARY, LONG_TERM_STAY, MULTI] as const;
export type DiscountTypeForQueryParams = (typeof DISCOUNT_TYPE)[keyof typeof DISCOUNT_TYPE];

export const DISCOUNT = {
	TYPE: {
		ORDINARY,
		LONG_TERM_STAY,
		MULTI,
	},
};
